// Widget Scripts
import customTicketBtn from './js/widgets/customTicketBtn.js';
import * as mainFeature from './js/widgets/main-feature/index.js';
import mozaicCards from './js/widgets/mozaicCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import * as tier4 from './js/widgets/tier-4-section/index.js';
import * as sponsorsSection from './js/widgets/sponsors-section/index.js';
import footerGallery from './js/widgets/footerGallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketBtn();

  if (globalThis.location.pathname === '/') {
    mainFeature.mainFeatureSlideshow();
    mainFeature.autoEventFeed();
    mozaicCards('mozaicCardsOne', mozaicCardsOneOpts, 2);
    mozaicCards('mozaicCardsTwo', mozaicCardsTwoOpts, 4);
    seoWidget();
    tier4.hotButtons();
    tier4.initSeoSocial();
    tier4.signupFeature();
    sponsorsSection.majorSponsors();
    sponsorsSection.scrollerSponsors();
    footerGallery();
  }
});
